<template lang="pug">
div.footer(:class="color")
    div.container
        div.row
            div.col.col-sm.order-sm-3.col-lg.social
                a.menu(:href="link.url" v-for="link in $store.state.links.follow.sublinks" target="_blank") {{ link.name }}
            div.col.col-sm-6.order-sm-1.order-sm-1.col-lg-auto.order-lg-2.contacts
                a.phone.menu(
                    v-if="$store.state.contacts.phone" 
                    :href="'tel:' + $store.state.contacts.phone.replace(/ +/g, '')"
                ) {{ $store.state.contacts.phone }}
                a.email.menu(
                    v-if="$store.state.contacts.email && $store.state.contacts.email.main" 
                    :href="'mailto:' + $store.state.contacts.email.main"
                ) {{ $store.state.contacts.email.main }}
            div.col-6.col-sm-auto.order-sm-2.col-lg-1.order-lg-1.copyright.info.text © {{ year }} Sota
            div.col-6.col-sm-auto.order-sm-4.col-lg-auto.order-lg-3.privacy.info.text
                router-link.menu(:to="getLocalizedUrl('/politika-konfidencialnosti')") {{ $t('$cookie.policy') }}
</template>

<script>
export default {
    name: 'Footer',
    props: {
        color: {
            type: [String, Boolean],
            default: "white"
        }
    },
    computed: {
        year: function () {
            var date = new Date();
            return date.getFullYear();
        }
    }
}
</script>

<style lang="scss">
@import "@styles/mixins.scss";
.footer.black {
    background-color: white;
    .info, .social a, .privacy a { color: black; }
    .privacy a { opacity: 0.6; }
    .contacts a {
        color: black;
        opacity: 0.4;
    }
}
.footer.white {
    .info, .social a, .privacy a { color: white; }
    .privacy a { opacity: 0.7; }
    .contacts a {
        color: white;
        opacity: 0.6;
    }
}
.footer {
    padding-bottom: 30px;
    padding-top: 30px;
    .row > div { margin-bottom: 30px; }
    .privacy a {
        font-size: 14px;
        line-height: 1.4;
        letter-spacing: -0.2px;
        transition: opacity .3s cubic-bezier(0.39, 0.575, 0.565, 1);
        &:hover { opacity: 1; }
    }
    .contacts {
        a { 
            margin-right: 30px; 
            transition: all .3s cubic-bezier(0.39, 0.575, 0.565, 1);
        }
        a:last-child { margin-right: 0; }
    }
    .social {
        text-align: right;
        a { margin-left: 30px; }
        a:first-child { margin-left: 0; }
    }
    @media (max-width: grid-breakpoint(lg)) {
        padding-bottom: 0;
        .contacts a { 
            margin-right: 0;
            display: block; 
        }
    }
    @media (max-width: grid-breakpoint(sm)) {
        .contacts { 
            text-align: right; 
            a { margin-bottom: 5px; }
        }
        .social {
            text-align: left;
            a { 
                margin-left: 0;
                display: block;
                margin-bottom: 5px; 
            }
        }
        .copyright {
            margin-bottom: 20px!important;
        }
    }
}
</style>
